import CloseIcon from '@mui/icons-material/Close';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import {AppBar, Button, IconButton, ScopedCssBaseline, Toolbar } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import jsPDF from 'jspdf';
import PropTypes from 'prop-types';
import React, {useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// import { Preview, print } from 'react-html2pdf';
// import { Preview, print } from 'react-html2pdf';
// import { Spinner } from 'react-bootstrap';
// import  from '../../../src/Assets/LOGOHTH.png';
import logoDataDelegates from '../../../src/Assets/LOGOHTH.png';
import { extractCountryName } from '../../data/Countries';
import { dureeBdcEnum, getFournisseurInfo, modeTravailEnum, regimeTravailEnum } from '../../data/Interfaces';
//import useAuth from '../../hooks/useAuth';
//import { Download } from '@mui/icons-material';
//import Logo from '../../data/Logo';
//import { formatDateJJMMYYYY } from '../../Utils/dateFormatter';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { useNumberFormatting } from '../../hooks/useNumberFormatting';
import useRole from '../../hooks/useRole';
import useUtilities from '../../hooks/useUtilities';
import useWindowSize from '../../hooks/useWindowSize';
import StatutDocument from '../../Pages/Client/DocAdministratifs/StatutDocument';
import { ordreMissionStyles } from '../../Styles/componentStyles';
import { formatDateJJMMYYYY } from '../../Utils/dateFormatter';
import { getNomPrenomClearFromPersoData, LabelSignaturePCOM, refPropositionCommerciale, searchLabelInEnumByValue, TestNullValue } from '../../Utils/utils';
import DialogRejet from '../Dialogs/DialogRejet';
import { buttonStyles, buttonStylesGreen } from '../docsAdministrative/JsObjectStyles';
import { SnackBarCustom,Transition } from '../shared/ReusableSmallComponents';

//const styleTitre = {
//    backgroundColor: '#e1e7f0',
//    color: '#126dff',
//    hieght: '20px',
//    width: '100%',
//    margin: '10px'
//};
//const subtitleStyle = {
//    color: 'blue',

//};

const PropCommerciale = ({ mission, handleClose, open }) => {

    PropCommerciale.propTypes = {
        children: PropTypes.any,
        mission: PropTypes.any,
        open: PropTypes.any,
        handleClose: PropTypes.func,
    };
    const { addEuro4Decimal } = useNumberFormatting();

    //const scroll = 'paper';
    //const [motifRejet, setMotifRejet] = useState('');
    const { openSnackBar, setOpenSnackBar, snackBarMessage, setSnackBarMessage } = useUtilities();

    const [openNested, setOpenNested] = useState(false);
    const [fournisseur,setFournisseur]=useState({});
    const [finalClient,setFinalClient]=useState();
    const {device}=useWindowSize();
    const { i18n } = useTranslation();
    //const { auth } = useAuth();
    const handleGeneratePdf = () => {
        //const doc = new jsPDF({
        //    format: [855/72,1000],
        //    unit: 'in',
        //});
        const doc = new jsPDF('p', 'pt', [1200/96*72, 1550/96*72]);

        doc.html(document.getElementById('reportTemplateRef'),
            {
                async callback(doc) {
                    await doc.save(refPropositionCommerciale(mission?.missionId));
                },
                margin: [40,0, 120,20], //[top, left, bottom, right]
                //pageSize: [855/96, null], // width x height in points
                //margin:[-20,48,100,0], //[a,a,bottom,right]
                autoPaging:'text',
            },

        );

    };

    //const handleGeneratePdf = () => {
    //    const doc = new jsPDF({
    //        format: 'a2',
    //        unit: 'px',
    //    });

    //    doc.html(document.getElementById('reportTemplateRef'),
    //        {
    //            async callback(doc) {
    //                await doc.save('document');
    //            },
    //            margin:[40,48,50,30],
    //            autoPaging:'text',
    //        },

    //    );
    //};

    //const [dateDebutMission, setDateDebutMission] = useState(null);

    const handleCloseNested = () => {
        setOpenNested(false);
    };

    const descriptionElementRef = React.useRef(null);
    // ? we focus on what here
    useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);

    useEffect(() => {
        if(mission){
            let fourniss={};
            console.log('mission',mission);
            fourniss.chargeRecrutement= getNomPrenomClearFromPersoData(mission?.BDCsOP[0]?.backOfficeId?.persoData);
            fourniss.tele=mission?.BDCsOP[0]?.backOfficeId?.persoData?.tele;
            fourniss.email=mission?.BDCsOP[0]?.backOfficeId?.persoData?.email;
            setFournisseur(fourniss);
            setFinalClient(mission?.companyDataId ?? mission?.esnId);
        }
    }, [mission]);

    const role= useRole();
    const axiosPrivate = useAxiosPrivate();

    const switchPropositionCommerciale = async (action) => {
        setOpenNested(false);
        console.log('action',action);
        try{
            const response1 = await axiosPrivate.post('/mission/switchPropositionCommerciale',
                { missionId: mission?.id, action }
            );
            const responseData1 = await response1.data;
            setSnackBarMessage(i18n.t(responseData1?.message));
        }catch (error) {
            console.log(error.response);
            setSnackBarMessage(i18n.t(error.response?.data?.error));
        }
        setOpenSnackBar(true);
    };

    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                fullScreen
                TransitionComponent={Transition}
                PaperProps={{
                    style: {
                        background: '#F5F6FA',
                        display: 'flex',
                        flexDirection:'row',
                        justifyContent:'center',
                        padding: '24px',
                    },
                }}
            >

                <AppBar>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                {mission &&
                    <div style={{display:'flex',width:'100%',flexDirection:device=='desktop'?'row':'column',justifyContent:'space-around',gap:device=='desktop'?'0px':'16px',background: '#F5F6FA',paddingTop: '90px',paddingBottom: '24px'}}>
                        <div className='OrdreMissionFile'>
                            <ScopedCssBaseline>
                                <div
                                    id='reportTemplateRef'
                                    style={ordreMissionStyles.page}
                                >
                                    <div
                                        style={ordreMissionStyles.logo}
                                    >
                                        {/*<img src={png} /> hth*/}
                                        <img src={logoDataDelegates}/>
                                        {/*<Logo />*/}
                                    </div>
                                    {mission &&
                                        <>
                                            <div style={ordreMissionStyles.FileFrame1Box1AppWidth123}>
                                                {/*<div style={ordreMissionStyles.OrdreMissionFileTitles2AppWidth}>
                                                    <div style={ordreMissionStyles.FieldsRow1}>
                                                        <p style={ordreMissionStyles.FieldsOrdreMissionFile}> Société:</p>
                                                        <p style={ordreMissionStyles.FieldsOrdreMissionFileContent}> {Fournisseur.societe}</p>
                                                    </div>
                                                    <div style={ordreMissionStyles.FieldsRow2}>
                                                        <p style={ordreMissionStyles.FieldsOrdreMissionFile}> Chargé de recrutement:</p>
                                                        <p style={ordreMissionStyles.FieldsOrdreMissionFileContent}>{Fournisseur.chargeRecrutement}</p>
                                                    </div>
                                                    <div style={ordreMissionStyles.FieldsRow3}>
                                                        <p style={ordreMissionStyles.FieldsOrdreMissionFile}> E-mail:</p>
                                                        <p style={ordreMissionStyles.FieldsOrdreMissionFileContent}>{Fournisseur.email}</p>
                                                    </div>
                                                    <div style={ordreMissionStyles.OrdreMissionFileFrame3F4}>
                                                        <p style={ordreMissionStyles.FieldsOrdreMissionFile}> Téléphone:</p>
                                                        <p style={ordreMissionStyles.FieldsOrdreMissionFileContent}>{Fournisseur.tele}</p>
                                                    </div>
                                                    <div style={ordreMissionStyles.OrdreMissionFileFrame3F5}>
                                                        <p style={ordreMissionStyles.FieldsOrdreMissionFile}> Siret:</p>
                                                        <p style={ordreMissionStyles.FieldsOrdreMissionFileContent}>{Fournisseur.siret}</p>
                                                    </div>
                                                </div>*/}
                                                <div style={ordreMissionStyles.OrdreMissionFileTitlesAppWidth}>
                                                    <h4 style={ordreMissionStyles.OrdreMissionFileTitle1AppWidth}> {i18n.t('Proposition commerciale')}</h4>

                                                </div>
                                                <div style={ordreMissionStyles.OrdreMissionFileSousTitlesAppWidth}>
                                                    <p style={ordreMissionStyles.OrdreMissionFileSousTitle2}>
                                                        {i18n.t('Réf')}:&nbsp;&nbsp;{refPropositionCommerciale(mission?.missionId)}
                                                    </p>
                                                    <p style={ordreMissionStyles.OrdreMissionFileSousTitle1}>
                                                        {i18n.t('Date d\'émission')}:&nbsp;&nbsp;{formatDateJJMMYYYY(mission?.createdAt)}
                                                    </p>
                                                </div>
                                            </div>
                                            <div style={ordreMissionStyles.OrdreMissionFileFrame3}>
                                                <h5 style={ordreMissionStyles.OrdreMissionFileFrame2}>{i18n.t('Fournisseur')}</h5>
                                                <div style={ordreMissionStyles.OrdreMissionFileFrame32}>
                                                    <div style={ordreMissionStyles.OrdreMissionFileFrame3F6}>
                                                        <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Intitule}> {i18n.t('Nom du commercial')}:</p>
                                                        <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>{fournisseur.chargeRecrutement}</p>
                                                    </div>
                                                    <div style={ordreMissionStyles.OrdreMissionFileFrame3F6}>
                                                        <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Intitule}> {i18n.t('Société')}:</p>
                                                        <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>{getFournisseurInfo(mission?.BDCsOP[0]?.backOfficeId?.persoData?.email).societe}</p>
                                                    </div>
                                                    <div style={ordreMissionStyles.OrdreMissionFileFrame3F6}>
                                                        <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Intitule}> {i18n.t('Adresse')}: </p>
                                                        <p style={ordreMissionStyles.OrdreMissionFileFrame3F1ContentLieu}>{getFournisseurInfo(mission?.BDCsOP[0]?.backOfficeId?.persoData?.email).adresse}</p>
                                                    </div>
                                                    <div style={ordreMissionStyles.OrdreMissionFileFrame3F6}>
                                                        <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Intitule}> {i18n.t('E-mail')}: </p>
                                                        <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>{fournisseur.email}</p>
                                                    </div>
                                                    <div style={ordreMissionStyles.OrdreMissionFileFrame3F6}>
                                                        <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Intitule}> {i18n.t('Téléphone')}: </p>
                                                        <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>{fournisseur.tele}</p>
                                                    </div>
                                                    <div style={ordreMissionStyles.OrdreMissionFileFrame3F6}>
                                                        <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Intitule}> {i18n.t('Siret')}: </p>
                                                        <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>{getFournisseurInfo(mission?.BDCsOP[0]?.backOfficeId?.persoData?.email).siret}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={ordreMissionStyles.OrdreMissionFileFrame4}>
                                                <h5 style={ordreMissionStyles.OrdreMissionFileFrame2}>{i18n.t('Client')}</h5>
                                                <div style={ordreMissionStyles.OrdreMissionFileFrame32}>
                                                    <div style={ordreMissionStyles.OrdreMissionFileFrame3F6}>
                                                        <p style={ordreMissionStyles.OrdreMissionF121212}> {i18n.t('Société')}:&nbsp;&nbsp;</p>
                                                        <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>{finalClient?.profileEntreprise?.nom}</p>
                                                    </div>
                                                    <div style={ordreMissionStyles.OrdreMissionFileFrame3F6}>
                                                        <p style={ordreMissionStyles.OrdreMissionF121212}> {i18n.t('Adresse')}:&nbsp;&nbsp;</p>
                                                        <p style={ordreMissionStyles.OrdreMissionFileFrame3F1ContentLieu}>{finalClient?.profileEntreprise?.address +', '+extractCountryName(finalClient?.profileEntreprise?.localisation)+ ', '+finalClient?.profileEntreprise?.codePostal }</p>
                                                    </div>
                                                    {/*On les masques pour #v0*/}
                                                    {/*<div style={ordreMissionStyles.OrdreMissionFileFrame3Row7}>
                                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F1Prime}>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntitulePrime}> Resp.Opérationnel:&nbsp;&nbsp;</p>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1ContentPrime}>{getNomPrenomClearFromPersoData(mission?.BDCsOP[0]?.responsableOperationnelId?.persoData)}</p>

                                                        </div>
                                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F11PrimeEmail}>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntitulePrime}> Email:&nbsp;&nbsp;</p>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1ContentPrime}>{mission?.BDCsOP[0]?.responsableOperationnelId?.persoData?.email}</p>

                                                        </div>
                                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F111}>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntitulePrime}> Tél:&nbsp;&nbsp;</p>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1ContentPrime}>{mission?.BDCsOP[0]?.responsableOperationnelId?.persoData?.tele}</p>

                                                        </div>
                                                    </div>*/}

                                                    {/*<div style={ordreMissionStyles.OrdreMissionFileFrame3Row8}>
                                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F1Prime}>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntitulePrime}> Resp.Achat:&nbsp;&nbsp;</p>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1ContentPrime}>{getNomPrenomClearFromPersoData(mission?.BDCsOP[0]?.responsableAchatId?.persoData)}</p>

                                                        </div>
                                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F11PrimeEmail}>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntitulePrime}> Email:&nbsp;&nbsp;</p>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1ContentPrime}>{mission?.BDCsOP[0]?.responsableAchatId?.persoData?.email}</p>
                                                        </div>
                                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F111}>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntitulePrime}> Tél:&nbsp;&nbsp;</p>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1ContentPrime}>{mission?.BDCsOP[0]?.responsableAchatId?.persoData?.tele}</p>
                                                        </div>
                                                    </div>*/}

                                                    {/*<div style={ordreMissionStyles.OrdreMissionFileFrame3Row9}>
                                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F1Prime}>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntitulePrime}> Resp.Comptabilité:&nbsp;&nbsp;</p>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1ContentPrime}>{getNomPrenomClearFromPersoData(mission?.BDCsOP[0]?.responsableComptabiliteId?.persoData)}</p>

                                                        </div>
                                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F11PrimeEmail}>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntitulePrime}> Email:&nbsp;&nbsp;</p>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1ContentPrime}>{mission?.BDCsOP[0]?.responsableComptabiliteId?.persoData?.email}</p>
                                                        </div>
                                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F111}>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntitulePrime}> Tél:&nbsp;&nbsp;</p>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1ContentPrime}>{mission?.BDCsOP[0]?.responsableComptabiliteId?.persoData?.tele}</p>
                                                        </div>
                                                    </div>*/}
                                                </div>
                                            </div>

                                            <div style={ordreMissionStyles.OrdreMissionFileFrame5}>

                                                <h5 style={ordreMissionStyles.OrdreMissionFileFrame2}>{i18n.t('Identification de la mission')}</h5>

                                                <div style={ordreMissionStyles.OrdreMissionFileFrame32}>
                                                    <div style={ordreMissionStyles.OrdreMissionFileFrame3Row1}>
                                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F1}>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntituleTwo}> {i18n.t('Référence de la mission')}:&nbsp;</p>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>{mission?.missionId}</p>
                                                        </div>
                                                        <div style={{width:'50%',display:'flex'}}>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntituleMiss}> {i18n.t('Intitulé de la mission')}:&nbsp;</p>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntituleMiss}>{mission?.titre}</p>
                                                        </div>
                                                    </div>
                                                    <div style={ordreMissionStyles.OrdreMissionFileFrame3Row2}>
                                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F1}>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntituleTwo}> {i18n.t('Date de démarrage BDC')}:&nbsp;</p>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}> {formatDateJJMMYYYY(mission?.BDCsOP[0]?.dateDebutBDC)}</p>

                                                        </div>
                                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F1}>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntituleTwo}> {i18n.t('Date de fin 1er BDC')}:&nbsp;</p>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>{formatDateJJMMYYYY(mission?.BDCsOP[0]?.dateFinBDC)}</p>

                                                        </div>
                                                    </div>
                                                    <div style={ordreMissionStyles.OrdreMissionFileFrame3Row3}>
                                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F1}>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntituleTwo}> {i18n.t('Nombre de jours (estimé)')}:&nbsp; </p>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>&nbsp;{mission?.BDCsOP[0]?.nbJoursBDC} </p>
                                                        </div>
                                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F1}>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntituleTwo}> {i18n.t('Lieu')}:&nbsp; </p>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1ContentLieu}>{mission?.localisation}</p>
                                                        </div>

                                                    </div>

                                                    <div style={ordreMissionStyles.OrdreMissionFileFrame3Row4}>
                                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F1}>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntituleTwo}> {i18n.t('Date de fin (estimée)')}:&nbsp; </p>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>{formatDateJJMMYYYY(mission?.dateFinMission)}</p>
                                                        </div>
                                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F1}>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntituleTwo}> {i18n.t('Fréq. de renouv.BDC')}:&nbsp; </p>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>{i18n.t(searchLabelInEnumByValue(dureeBdcEnum,mission?.BDCsOP[0]?.frequenceRenouv))}</p>
                                                        </div>
                                                    </div>

                                                    <div style={ordreMissionStyles.OrdreMissionFileFrame3Row5}>
                                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F1}>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntituleTwo}> {i18n.t('Régime de mission')}:&nbsp; </p>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>{i18n.t(searchLabelInEnumByValue(regimeTravailEnum,mission?.BDCsOP[0]?.regimeTravail?.type))} </p>
                                                        </div>

                                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F1}>
                                                            <p style={ordreMissionStyles.AppLineH}> {i18n.t('Nb de jours (si temps partiel)')}:&nbsp; </p>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1ContentLieu}>{typeof(mission?.BDCsOP[0][0]?.regimeTravail?.nbJrsPartielPerWeek)!='undefined'? ' ': TestNullValue(mission?.BDCsOP[0]?.regimeTravail?.nbJrsPartielPerWeek)}</p>
                                                        </div>

                                                    </div>

                                                    <div style={ordreMissionStyles.OrdreMissionFileFrame3Row6}>
                                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F1}>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntituleTwo}> {i18n.t('Mode de travail')}:&nbsp; </p>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>{i18n.t(searchLabelInEnumByValue(modeTravailEnum,mission?.BDCsOP[0]?.modeTravail?.type))}</p>
                                                        </div>
                                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F1}>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntituleTwo}> {i18n.t('Fréquence (télétravail)')}:&nbsp; </p>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>{TestNullValue(mission?.BDCsOP[0]?.modeTravail?.nbJrsRemotePerWeek)!=' ' ? TestNullValue(mission?.BDCsOP[0]?.modeTravail?.nbJrsRemotePerWeek)+' Jours' :' '}</p>
                                                        </div>
                                                    </div>
                                                    {/*<div style={ordreMissionStyles.OrdreMissionFileFrame3Row1}>
                                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F1}>
                                                            <p style={ordreMissionStyles.OrdreMissionFile232323}> Réf. de la mission:</p>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content33}>{' '+mission?.missionId}</p>
                                                        </div>
                                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F11}>
                                                            <p style={ordreMissionStyles.OrdreMissionFile2323234}> Intitulé de la mission:</p>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content4}>{' '+mission?.titre}</p>
                                                        </div>
                                                    </div>
                                                    <div style={ordreMissionStyles.OrdreMissionFileFrame3Row2}>
                                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F1}>
                                                            <p style={ordreMissionStyles.OrdreMissionFile232323}> Date de démarrage:</p>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content33}> &nbsp;{formatDateJJMMYYYY(mission?.dateDebutMission)}</p>

                                                        </div>
                                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F11}>
                                                            <p style={ordreMissionStyles.OrdreMissionFile2323234}> Date de fin 1er BDC:</p>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content4}>{' '+formatDateJJMMYYYY(mission?.BDCsOP[0]?.dateFinBDC)}</p>

                                                        </div>
                                                    </div>
                                                    <div style={ordreMissionStyles.OrdreMissionFileFrame3Row3}>
                                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F1}>
                                                            <p style={ordreMissionStyles.OrdreMissionFile232323}> Nb. de jours BDC: </p>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content33}>{' '+mission?.BDCsOP[0]?.nbJoursBDC}</p>
                                                        </div>
                                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F11}>
                                                            <p style={ordreMissionStyles.OrdreMissionFile2323234}>Lieu: </p>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content4}>&nbsp;{' '+mission?.localisation}  </p>
                                                        </div>
                                                    </div>

                                                    <div style={ordreMissionStyles.OrdreMissionFileFrame3Row5}>
                                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F1}>
                                                            <p style={ordreMissionStyles.OrdreMissionFile232323}> Date de fin (estimé): </p>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content33}>{' '+formatDateJJMMYYYY(mission?.dateFinMission)}</p>
                                                        </div>
                                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F11}>
                                                            <p style={ordreMissionStyles.OrdreMissionFile2323234}> Fréq. de renouv.BDC: </p>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content4}>&nbsp;{searchLabelInEnumByValue(dureeBdcEnum,mission?.BDCsOP[0]?.frequenceRenouv)}</p>
                                                        </div>
                                                    </div>

                                                    <div style={ordreMissionStyles.OrdreMissionFileFrame3Row4}>
                                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F1}>
                                                            <p style={ordreMissionStyles.OrdreMissionFile232323}> Régime de mission: </p>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content33}> &nbsp; {searchLabelInEnumByValue(regimeTravailEnum,mission?.BDCsOP[0]?.regimeTravail?.type)} </p>
                                                        </div>
                                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F11}>
                                                            <p style={ordreMissionStyles.OrdreMissionFile2323234}>Nb de jours (si temps partiel):</p>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content4}>{typeof(mission?.BDCsOP[0]?.regimeTravail?.nbJrsPartielPerWeek)!='undefined'? ' '+mission?.BDCsOP[0]?.regimeTravail?.nbJrsPartielPerWeek:' '}</p>
                                                        </div>
                                                    </div>

                                                    <div style={ordreMissionStyles.OrdreMissionFileFrame3Row6}>
                                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F1}>
                                                            <p style={ordreMissionStyles.OrdreMissionFile232323}> Mode de travail:</p>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content33}>{searchLabelInEnumByValue(modeTravailEnum,mission?.BDCsOP[0]?.modeTravail?.type)}</p>
                                                        </div>
                                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F11}>
                                                            <p style={ordreMissionStyles.OrdreMissionFile2323234}> Fréq. (télétravail): </p>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content4}>{' '+mission?.BDCsOP[0]?.modeTravail?.nbJrsRemotePerWeek+' jours'}</p>
                                                        </div>
                                                    </div>*/}
                                                </div>
                                            </div>
                                            <div style={ordreMissionStyles.OrdreMissionFileFrame6}>
                                                <h5 style={ordreMissionStyles.OrdreMissionFileFrame2}>{i18n.t('Vos obligations')}</h5>
                                                <div style={ordreMissionStyles.OrdreMissionFileFrame32}>
                                                    <ul>
                                                        <li style={ordreMissionStyles.ListStyle}>{i18n.t('Vous devez prendre connaissance et respecter le règlement intérieur et toutes les politiques et procédures du client.')}</li>
                                                        <li style={ordreMissionStyles.ListStyle}>{i18n.t('Vous devez respecter le secret professionnel vis-à-vis des informations obtenues chez le client.')}</li>
                                                        <li style={ordreMissionStyles.ListStyle}>{i18n.t('Vous devez prendre connaissance et respecter les dispositions spécifiques de sécurité chez le client.')}</li>
                                                    </ul>
                                                </div>
                                            </div>

                                            <div style={ordreMissionStyles.OrdreMissionFileFrame7}>
                                                <h5 style={ordreMissionStyles.OrdreMissionFileFrame2}>{i18n.t('Durant la mission')}</h5>
                                                <div style={ordreMissionStyles.OrdreMissionFileFrame32}>
                                                    <ul>
                                                        <li style={ordreMissionStyles.ListStyle}>{i18n.t('Chaque fin de mois, vous serez invité à valider le compte rendu d\'activité (CRA) mensuelle pour le mois écoulé du consultant une fois validé par ce dernier; ce qui va permettre par la suite de générer la facture de la prestation.')}</li>
                                                        <li style={ordreMissionStyles.ListStyle}>{i18n.t('Pour n\'importe quel problème contactez le chargé de recrutement.')}</li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div style={ordreMissionStyles.OrdreMissionFileFrame7}>
                                                <h5 style={ordreMissionStyles.OrdreMissionFileFrame2}>{i18n.t('Facturation')}</h5>
                                                <div style={ordreMissionStyles.OrdreMissionFileFrame32}>
                                                    <ul>
                                                        <li style={ordreMissionStyles.ListStyle}>{i18n.t('Délais de paiement défini par le client est : ')}{mission?.xx}  {i18n.t('jours, à compter de la fin du mois de la prestation, à condition de la validation du compte rendu d\'activité par le consultant et le client.')}</li>
                                                        <li style={ordreMissionStyles.ListStyle}>{i18n.t('La facture est générée par le système une fois le compte rendu d\'activité(CRA) est validé par le consultant et le client.')}</li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div style={ordreMissionStyles.OrdreMissionFileFrame8}>
                                                <h5 style={ordreMissionStyles.OrdreMissionFileFrame2}>{i18n.t('Conditions particulières et préavis')}</h5>
                                                <div style={ordreMissionStyles.OrdreMissionFileFrame32}>
                                                    <ul>
                                                        <li style={ordreMissionStyles.ListStyle}>{i18n.t('La validation de la proposition commerciale sur la plateforme est considérée une signature électronique du document, qui va permettre de générer le 1er bon de commande. Tout nouveau renouvellement de ce dernier se fera automatiquement par le système après accord entre le client et le consultant.')}</li>
                                                        <li style={ordreMissionStyles.ListStyle}>{i18n.t('Si le consultant ou le client veut interrompre une mission en cours, il faut envisager un préavis de 30 jours.')}</li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div style={ordreMissionStyles.OrdreMissionFileFrame9}>
                                                <h5 style={ordreMissionStyles.OrdreMissionFileFrame2}>{i18n.t('Prix de la prestation')}</h5>
                                                <div style={ordreMissionStyles.OrdreMissionFileFrame32}>
                                                    <div style={ordreMissionStyles.OrdreMissionFileFrame3Row1}>
                                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F6}>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntituleTwo}> {i18n.t('Taux journalier (HT)')}:&nbsp;</p>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>
                                                                {addEuro4Decimal(mission?.BDCsOP[0]?.tjClient)}
                                                            </p>
                                                        </div>
                                                    </div>

                                                    {/*<div style={ordreMissionStyles.OrdreMissionFileFrame3Row1}>
                                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F1}>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Intitule}> Taux journalier (HT):</p>
                                                            tauxJournaalier client  (expert+ commission)
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>{addEuro4Decimal(mission?.BDCsOP[0]?.tjClient)}</p>
                                                        </div>
                                                    </div>*/}

                                                    <div style={ordreMissionStyles.OrdreMissionFileFrame3Row2}>
                                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F6}>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1IntituleTwo}> {i18n.t('Frais de déplacement')}:&nbsp;</p>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Content}>{i18n.t('Soumis à l\'accord entre le client et l\'expert')}</p>
                                                        </div>
                                                    </div>

                                                    {/*<div style={ordreMissionStyles.OrdreMissionFileFrame3Row2}>
                                                        <div style={ordreMissionStyles.OrdreMissionFileFrame3F1}>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Intitule}> Frais de déplacement:</p>
                                                            <p style={ordreMissionStyles.OrdreMissionFileFrame3F1ContentFraisDep}> Exceptionnelle soumis à l&apos;accord entre le client et l&apos;expert</p>
                                                        </div>
                                                    </div>*/}
                                                </div>
                                            </div>
                                            <div style={ordreMissionStyles.OrdreMissionFileFrame10}>
                                                <p style={ordreMissionStyles.OrdreMissionFileFrame3F1Intitule}>{i18n.t(LabelSignaturePCOM(mission?.propositionCommerciale?.statut))+':'}</p>
                                                <p style={ordreMissionStyles.OrdreMissionFileFrame3F1ContentFraisDep}>{formatDateJJMMYYYY(mission?.propositionCommerciale?.dateSignature)}</p>
                                            </div>
                                        </>
                                    }

                                </div>

                            </ScopedCssBaseline>
                        </div>
                        {device!='desktop' &&
                            <Button
                                className='TelechargerMissionOM'
                                //onClick={printOrdreMission}
                                onClick={handleGeneratePdf}
                                variant="text"
                                style={{...buttonStyles(),...{color:'#272D3C',background:device=='desktop'?'none':'#E7EAF9',order:1,width:'100%'}}}

                                startIcon={<FileDownloadOutlinedIcon style={{color:'#272D3C'}} />}
                                //onClick={handleExportWithComponent}
                            >
                                {i18n.t('Télécharger')}
                            </Button>
                        }

                        <div className='Frame123OM'>
                            {/*<div className='frame00FicheCollab'>
                                <div className='frame01FicheCollab'>
                                    <IconButton onClick={handleClose}>
                                        <CloseIcon />
                                    </IconButton>

                                </div>
                            </div>*/}
                            {device!='desktop' &&
                                <div style={{display:'flex',flexDirection:'column',gap:'16px',width:'100%'}}>
                                    <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',width:'100%'}}>
                                        <h5 className='TitleFrame1OM'>
                                            {i18n.t('Proposition commerciale')}
                                        </h5>
                                        <IconButton
                                            //className='TelechargerMissionOM'
                                            //onClick={printOrdreMission}
                                            onClick={handleGeneratePdf}
                                            variant="outlined"
                                            style={{...buttonStyles(),...{color:'#214DCE',border: '1px solid #214DCE',order:2,margin:'0'}}}

                                            //startIcon={<FileDownloadOutlinedIcon style={{color:'#214DCE',margin:'0px'}} />}
                                            //onClick={handleExportWithComponent}
                                        >
                                            <FileDownloadOutlinedIcon style={{color:'#214DCE',margin:'0px'}} />
                                        </IconButton>
                                    </div>
                                    <div style={{borderBottom:'solid 2px #C3C9F1',margin:'0px'}}></div>
                                </div>
                            }

                            <div style={{display:'flex',flexDirection:'column',gap:'12px'}}>
                                <StatutDocument
                                    statut={mission?.propositionCommerciale?.statut}
                                    motifRejet={mission?.propositionCommerciale?.motifRejet}
                                />

                                {mission?.propositionCommerciale?.dateSignature && (
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            fontFamily: 'Lato',
                                            fontStyle: 'normal',
                                            fontWeight: '400',
                                            fontSize: '12px',
                                            lineHeight: '16px',
                                            alignItems: 'flex-start',
                                            textAlign: 'flex-start',
                                            letterSpacing: '0.004em',
                                            color: '#475063',
                                        }}
                                    >
                                        <p style={{margin:'0'}}>{mission?.propositionCommerciale?.statut=='rejete' ?i18n.t('Rejetée Par: ') :i18n.t('Signée Par: ')} {getNomPrenomClearFromPersoData(mission?.propositionCommerciale?.collaboratorId?.persoData ?? mission?.propositionCommerciale?.collaboratorEsnId?.persoData)}</p>

                                        <p style={{margin:'0'}}>{mission?.propositionCommerciale?.statut=='rejete' ?i18n.t('Rejetée le: ') :i18n.t('Signée le: ')} {formatDateJJMMYYYY(mission?.propositionCommerciale?.dateSignature)}</p>
                                    </div>
                                )}
                            </div>
                            {device=='desktop' &&
                                <h5 className='TitleFrame1OM'>
                                    {i18n.t('Proposition commerciale')}
                                </h5>
                            }
                            <div className='Frame2OM'>
                                <h6 className='TitleFrame2OM'>
                                    {mission?.titre}
                                </h6>
                                <div className='Frame23OM'>
                                    <div className='Frame23COM'>
                                        <img
                                            src={finalClient?.profileEntreprise?.logo}
                                            className='ImageOM'
                                        />
                                        <div className='TextImageOM'>
                                            <p className='Title1Frame3OM'>
                                                {finalClient?.profileEntreprise?.nom}
                                            </p>
                                            <p className='Title2Frame3OM'>
                                                {i18n.t('Réf')}:&nbsp;&nbsp;{refPropositionCommerciale(mission?.missionId)}
                                            </p>
                                        </div>
                                    </div>

                                </div>

                            </div>

                            {device=='desktop' &&
                            <div className='Frame9OM'>

                                <div className='Frame4OMBox2OM'>
                                    <Button
                                        className='TelechargerMissionOM'
                                        //onClick={printOrdreMission}
                                        onClick={handleGeneratePdf}
                                        variant="text"
                                        style={{...buttonStyles(),...{color:'#272D3C',background:'#E7EAF9',width:'100%'}}}
                                        startIcon={<FileDownloadOutlinedIcon style={{color:'#272D3C'}} />}
                                        //onClick={handleExportWithComponent}
                                    >
                                        {/*{children}
                                        <Spinner
                                            animation="border"
                                            role="status"
                                            hidden={propoditionCommLoaded}
                                        >
                                            <span className="visually-hidden">Loading...</span>
                                        </Spinner>*/}
                                        {i18n.t('Télécharger')}
                                    </Button>
                                </div>
                            </div>
                            }

                            {(role == 'expert' || role == 'client' || role=='esn') && (mission?.statut!='signe') &&
                                <>
                                    <div className='LineVect2OM'>
                                    </div>

                                    <div className='Frame6OM'>
                                        <div className='Frame6OMBtn'>
                                            {(mission?.statut!='rejete') &&
                                                <div className='RejeterOM'>
                                                    <Button
                                                        variant='text'
                                                        style={{...buttonStyles()}}

                                                        onClick={()=>{
                                                            setOpenNested(true);
                                                        }}
                                                    >
                                                        {i18n.t('Rejeter')}
                                                    </Button>
                                                </div>
                                            }
                                            <div className='AccepterOM'>
                                                <Button
                                                    variant='contained'
                                                    style={{...buttonStylesGreen(false)}}
                                                    onClick={async () => {
                                                        await switchPropositionCommerciale('accept');
                                                        handleClose();
                                                    }}
                                                >
                                                    {i18n.t('Valider')}
                                                </Button>
                                            </div>

                                        </div>

                                    </div>
                                </>
                            }
                        </div>

                    </div>
                }

                <DialogRejet
                    handleCloseDialogRejet={()=>{
                        handleCloseNested();
                        handleClose();
                    }}
                    openDialogRejet={openNested}
                    missionIdProposition={mission?.id}
                />
                <SnackBarCustom
                    snackBarMessage={snackBarMessage}
                    openSnackBar={openSnackBar}
                    setOpenSnackBar={setOpenSnackBar}
                />
            </Dialog>

        </>
    );
};

export default PropCommerciale;

{/*<div className='row'>
<div className='col-9 p-5'>
    <Preview id={'jsx-template'} >
        <Logo />
        <h5 style={{ textAlign: 'center' }}> Proposition commerciale</h5>
        <div
            style={styleTitre}
        >
            <p>
                Numéro de l&apos;ordre de mission: PC##{mission.missionId}
            </p>
            <p>
                Date d&apos;émision: {formatDateJJMMYYYY(mission.createdAt)}
            </p>
        </div>
        <p style={subtitleStyle}> {JSON.stringify(mission)}</p>

    </Preview>
</div>
<div className='col-3 p-5'>
    <h4>Proposition commerciale </h4>
    <p>{mission?.titre}</p>

    <Button
        variant='outlined'
        startIcon={<Download />}
        sx={{ bgColor: 'palette.success.light' }}
        onClick={printPropCommercial}
    >
        Télécharger l&apos;ordre de mission
    </Button>
    <br />
    <br />
    <div id='propositionCommDiv'>
        <Button
            variant='text'
            sx={{ bgColor: 'palette.success.light' }}
            onClick={handleClickOpenNested}
        >
            rejeter
        </Button>
        <Button
            variant='contained'
            color='success'
            sx={{ bgColor: 'palette.success.light' }}
            onClick={() => switchPropositionCommerciale('accept')}
        >
            Valider
        </Button>
        <Dialog
            open={openNested}
            onClose={handleCloseNested}
        >
            <DialogContent>
                <p>
                    votre motif de Rejet
                </p>
                <TextField
                    id="outlined-multiline-flexible"
                    label='Note'
                    // placeholder="Entrer içi un commentaire:"
                    multiline
                    minRows={4}
                    style={{ width: 200 }}
                    value={motifRejet}
                    onChange={(e) => setMotifRejet(e.target.value)}
                    autoFocus
                    margin="dense"
                    fullWidth
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseNested}>Cancel</Button>
                <Button onClick={()=> switchPropositionCommerciale('reject')}>Envoyer</Button>
            </DialogActions>
        </Dialog>
        <Snackbar
            open={openSnackBar}
            autoHideDuration={6000}
            onClose={handleCloseSnackBar}
        >
            <Alert
                onClose={handleCloseSnackBar}
                severity="info"
                sx={{ width: '100%' }}
            >
              message: { message}
            </Alert>
        </Snackbar>
    </div>
</div>
</div>*/}
